import {GET_RESOLVED_PROPERTY} from '../symbols';
import {HOIST_ATTR, NOW_HOIST_PROP, NOW_HOIST_ATTR} from '../constants';

export default function isHoisted(host) {
	return (
		host[GET_RESOLVED_PROPERTY](HOIST_ATTR) ||
		host[GET_RESOLVED_PROPERTY](NOW_HOIST_PROP) ||
		host.hasAttribute(NOW_HOIST_ATTR) ||
		host.hasAttribute(HOIST_ATTR)
	);
}
